module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/line.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "toc"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ack.htm"
    }
  }, [_vm._v("Acknowledgments")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/intro.htm"
    }
  }, [_vm._v("Introduction: Reversed Colonialism")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch01.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ONE")]), _vm._v(" Conquest")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch02.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TWO")]), _vm._v(" New Order")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch03.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THREE")]), _vm._v(" The Embrace")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch04.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOUR")]), _vm._v(" The Empire of the Plains")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch05.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIVE")]), _vm._v(" Greater Comanchería")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch06.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SIX")]), _vm._v(" Children of the Sun")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch07.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SEVEN")]), _vm._v(" Hunger")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch08.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EIGHT")]), _vm._v(" Collapse")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/conclusion.htm"
    }
  }, [_vm._v("Conclusion: The Shape of Power")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/abb.htm"
    }
  }, [_vm._v("List of Abbreviations")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/note1.htm"
    }
  }, [_vm._v("Notes")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/bib.htm"
    }
  }, [_vm._v("Bibliography")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/index.htm"
    }
  }, [_vm._v("Index")]), _c('br'), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 69
// module chunks = 0